import enumeration from "./enumeration";

const TapStatus = {
  Success: "SUCCESS",
  Failed: "FAILED",
  Pending: "PENDING",
};

export default enumeration(TapStatus);
